"use strict";

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Icon_1 = require("../../atoms/Icon");

var IconLink_1 = require("../IconLink");

var _SelectWidget_1 = require("../InputSelect/_SelectWidget");

var ComplexTableActionMenu =
/** @class */
function (_super) {
  __extends(ComplexTableActionMenu, _super);

  function ComplexTableActionMenu(props) {
    var _this = _super.call(this, props) || this;

    _this.actionMenuRef = React.createRef();

    _this.onEscape = function () {
      _this.setState(function () {
        return {
          widgetOpen: false
        };
      });
    };

    _this.onIconWidgetOpenClick = function () {
      _this.setState(function (oldState) {
        return {
          widgetOpen: !oldState.widgetOpen,
          openAbove: _this.shouldWidgetOpenAbove()
        };
      });
    };

    _this.state = {
      widgetOpen: false,
      openAbove: false
    };
    return _this;
  }

  ComplexTableActionMenu.prototype.render = function () {
    var tableActionsProperties = this.props.tableActionsProperties;
    var verticalMenuActionProps = [];
    var horizontalMenuActionProps = [];

    if (this.props.isMobile) {
      verticalMenuActionProps = tableActionsProperties;
    } else if (tableActionsProperties.length <= 3) {
      horizontalMenuActionProps = tableActionsProperties;
    } else {
      verticalMenuActionProps = tableActionsProperties.slice(2);
      horizontalMenuActionProps = tableActionsProperties.slice(0, 2);
    }

    var options = verticalMenuActionProps.map(function (actionProperty, index) {
      return {
        label: actionProperty.children,
        value: index.toString(),
        disabled: actionProperty.disabled,
        iconLinkProps: actionProperty
      };
    });
    return React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "complextable-actionmenu-iconlink",
      ref: this.actionMenuRef
    }, React.createElement(IconLink_1.IconLinkGroup, {
      className: CSSPrefix_1.lsgPre + "complextable-td-action-wrapper",
      direction: IconLink_1.IconLinkGroup.Directions.TABLE
    }, horizontalMenuActionProps.map(function (actionProp, index) {
      return React.createElement(IconLink_1.IconLink, __assign({
        key: index
      }, actionProp, {
        look: IconLink_1.IconLink.Looks.NO_TEXT
      }));
    }), verticalMenuActionProps.length > 0 && React.createElement(IconLink_1.IconLink, {
      className: CSSPrefix_1.lsgPre + "complextable-actionmenu-iconlink",
      onClick: this.onIconWidgetOpenClick,
      iconName: Icon_1.Icon.Names.interaction___more02,
      iconOnly: true
    })), this.state.widgetOpen && React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "complextable-actionmenu-selectwidget"
    }, React.createElement(_SelectWidget_1.SelectWidget, {
      onChange: this.onEscape,
      onEscape: this.onEscape,
      options: options,
      openAbove: this.state.openAbove
    })));
  };

  ComplexTableActionMenu.prototype.shouldWidgetOpenAbove = function () {
    if (!this.actionMenuRef.current) {
      return false;
    }

    return utils_1.WindowEvents.shouldWidgetOpenAbove(this.actionMenuRef.current);
  };

  return ComplexTableActionMenu;
}(React.Component);

exports.ComplexTableActionMenu = ComplexTableActionMenu;